import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

import PCContainer from "../components/atoms/layout/pcContainer";

import useDisplay from "../hooks/useDisplay";
import { route } from "../router/route";

import Pagination from "../components/molecules/pagination";
import Empty from "../components/molecules/empty";
import LSRgDisplay02 from "../components/molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LectureItemPage from "../components/organisms/lecture/lectureItemPage";
import LectureApi from "../api/lecture.api";
import { errorHandler } from "../util/errorHandler";

const Search = () => {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { legacyPage } = useParams();

  const [keyword, setKeyword] = useState("");
  const [searchProductList, setSearchProductList] = useState([]);

  const page = useMemo(() => {
    const requestedPage = Number(searchParams.get("page") ?? legacyPage);
    return Number.isInteger(requestedPage) && requestedPage > 0
      ? requestedPage
      : 1;
  }, [legacyPage, searchParams]);

  const [pagination, setPagination] = useState({
    size: 9, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");

    dataListFunc();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const dataListFunc = async () => {
    try {
      const data = {
        page: page,
        size: pagination.size,
        keyword: searchParams.get("keyword") ? searchParams.get("keyword") : "",
        activation: "Active",
      };

      const response = (await LectureApi.getList(data)).data.data;

      setSearchProductList(response.content ?? []);
      setPagination((prev) => ({
        ...prev,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / pagination.size),
      }));
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <SearchSection>
        <PCContainer
          style={{
            flexDirection: "column",
            padding: isSmall ? "40px 20px 80px 20px" : "90px 0px 150px 0px",
            width: "100%",
          }}
        >
          <LSRgDisplay02
            style={{
              color: "#000000",
              marginBottom: isMobile ? 16 : isTablet ? 30 : 60,
              fontSize: isMobile ? 14 : 24,
              lineHeight: isMobile ? "19.6px" : "33.6px",
            }}
          >
            🔎 {keyword} 검색 결과
          </LSRgDisplay02>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: isMobile ? "19px 0px" : "30px",
                flexDirection: "row",
                justifyContent: isSmall ? "space-between" : "flex-start",
                flexWrap: "wrap",
                width: "100%",
              }}
            >
              {searchProductList.length > 0 ? (
                searchProductList.map((item) => {
                  return <LectureItemPage key={item.id} data={item} />;
                })
              ) : (
                <Empty title={"검색 결과가 없습니다."} />
              )}
            </div>
          </div>

          {searchProductList.length > 0 ? (
            <Pagination
              route={route.search}
              queryString={`keyword=${encodeURIComponent(keyword)}`}
              currentPage={Number(page)}
              totalPages={pagination.totalPages}
              rangeSize={pagination.rangeSize}
            />
          ) : null}
        </PCContainer>
      </SearchSection>
    </>
  );
};

export default Search;

const SearchSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;
